import React, { useState, useEffect } from 'react';
import { ref, onValue } from 'firebase/database';
import { database } from '../firebase';
import './BlogPreview.css';

const BlogPreview = ({ onNavigate }) => {
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    const blogRef = ref(database, 'blog');
    const unsubscribe = onValue(blogRef, (snapshot) => {
      const data = snapshot.val();
      if (data) {
        const list = Object.keys(data).map(key => ({ id: key, ...data[key] }));
        setPosts(list.sort((a, b) => new Date(b.date || 0) - new Date(a.date || 0)));
      } else {
        setPosts([]);
      }
    });
    return () => unsubscribe();
  }, []);

  const displayPosts = posts.slice(0, 3);
  const formatDate = (d) => {
    if (!d) return '';
    return new Date(d).toLocaleDateString('tr-TR', { day: 'numeric', month: 'long', year: 'numeric' });
  };

  return (
    <section id="blog" className="blog-preview">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">Blog</h2>
          <p className="section-subtitle">Son yazılar ve içerikler</p>
        </div>
        {posts.length === 0 ? (
          <p className="blog-preview-empty">Henüz blog yazısı yok.</p>
        ) : (
          <>
            <div className="blog-preview-grid">
              {displayPosts.map((post) => (
                <article key={post.id} className="blog-preview-card">
                  <h3 className="blog-preview-title">{post.title}</h3>
                  {post.date && <time className="blog-preview-date">{formatDate(post.date)}</time>}
                  <p className="blog-preview-excerpt">{post.excerpt || post.content}</p>
                </article>
              ))}
            </div>
            {onNavigate && (
              <div className="blog-preview-cta">
                <button type="button" className="view-all-btn" onClick={() => onNavigate('blog')}>
                  Tümünü görüntüle
                </button>
              </div>
            )}
          </>
        )}
      </div>
    </section>
  );
};

export default BlogPreview;
